/** Zustand persist key — must match `name` in `agentSelectedBot.store.ts` and `clearAuthClientStorage`. */
export const AGENT_SELECTED_BOT_STORAGE_KEY = 'agent-selected-bot-v1';
